import type { DocumentStatus, TruckComplianceStatus } from '@chukua/common';

/** Tag colour and label for one document type's status — a truck's, trailer's or driver's Documents tab (gitaumoses4/chukua#17). */
export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, { label: string; color: string }> = {
  valid: { label: 'Valid', color: 'success' },
  expiring_soon: { label: 'Expiring soon', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
  missing: { label: 'Missing', color: 'default' },
};

/**
 * The worst-of-what-exists status the trucks list column and detail-page tag show —
 * unmodified in intent by #17: never widened to react to a missing document type,
 * so it keeps the older `none` vocabulary rather than `missing`.
 */
export const COMPLIANCE_LABELS: Record<TruckComplianceStatus, { label: string; color: string }> = {
  valid: DOCUMENT_STATUS_LABELS.valid,
  expiring_soon: DOCUMENT_STATUS_LABELS.expiring_soon,
  expired: DOCUMENT_STATUS_LABELS.expired,
  none: { label: 'No documents', color: 'default' },
};
